<template>
  <scrollable full>
    <!-- ********************************
    ********** GESTION TICKETS **********
    ********************************* -->
    <manage-tickets />

    <v-btn
      block
      x-large
      color="success"
      class="mt-2"
      @click="startConfig"
    >
      Démarrer la configuration
    </v-btn>

    <pax-config-line
      :text="`${$t('words.beneficiary')} ${paymentParams.beneficiary.Beneficiary}`"
      :status="benefStatus"
    />

    <pax-config-line
      :text="`${$t('words.gateway')} ${paymentParams.gateway.Gateway}`"
      :status="gatewayStatus"
    />

    <pax-config-line
      v-for="(instance, i) in paymentParams.instance"
      :key="i"
      :text="instance.InstanceName"
      :status="instanceStatus[i]"
    />
  </scrollable>
</template>

<script>
import ManageTickets from '@/components/settings/banking/ManageTickets'
import PaxConfigLine from '@/components/settings/banking/PaxConfigLine'
import { $alert } from '@/modules/Utils'

export default {
  name: 'Pax',

  components: {
    PaxConfigLine,
    ManageTickets
  },

  data () {
    return {
      // 0 = none, 1 = success, 2 = error
      benefStatus: 0,
      gatewayStatus: 0,
      instanceStatus: Array.from({ length: this.$store.getters.paymentParams.instance.length }, _ => 0),
    }
  },

  computed: {
    paymentParams () {
      return this.$store.getters.paymentParams
    }
  },

  methods: {
    async startConfig () {
      // Check bénéficiaire existe déjà
      await this.beneficiaryExist()
      // pas de bénéficiaire, on l'ajoute
      if (this.benefStatus === 0) {
        await this.addBeneficiary()
      }

      // Bénéficiaire OK, on check la gateway
      if (this.benefStatus === 2) {
        // Ajout ou check du bénéficiaire en erreur
        // On arrête la configuration
        return
      }

      // Check gateway existe déjà
      await this.gatewayExist()
      // pas de gateway, on l'ajoute
      if (this.gatewayStatus === 0) {
        await this.addGateway()
      }

      // Bénéficiaire OK, on check les instances
      if (this.gatewayStatus === 2) {
        // Ajout ou check de la gateway en erreur
        // On arrête la configuration
        return
      }

      // Check instances existe déjà
      await this.instanceExist()

      // Pour chaque instance, si elle n'est pas en erreur ou n'existe pas déjà, on l'ajoute
      for (let i = 0; i < this.instanceStatus.length; i++) {
        if (this.instanceStatus[i] === 0) {
          await this.addInstance(i)
        }
      }

      if (this.instanceStatus.findIndex(status => status === 2) === -1) {
        await this.request('TLP')
      }
    },
    // ***** BENEFICIARY *****
    beneficiaryExist () {
      return this.request('BENEF_LIST')
        .then(response => {
          if (response.BeneficiaryCount > 0) {
            for (let i = 0; i < response.BeneficiaryCount; i++) {
              if (response[`Beneficiary${i}`] === this.paymentParams.beneficiary.Beneficiary) {
                this.benefStatus = 1
              }
            }
          }
        })
        .catch(error => {
          this.benefStatus = 2

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    addBeneficiary () {
      return this.request('BENEF_ADD', this.paymentParams.beneficiary)
        .then(_ => {
          this.benefStatus = 1
        })
        .catch(error => {
          this.benefStatus = 2

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    // ***** GATEWAY *****
    gatewayExist () {
      return this.request('GATEWAY_LIST')
        .then(response => {
          if (response.GatewayCount > 0) {
            for (let i = 0; i < response.GatewayCount; i++) {
              if (response[`Gateway${i}`] === this.paymentParams.gateway.Gateway) {
                this.gatewayStatus = 1
              }
            }
          }
        })
        .catch(error => {
          this.gatewayStatus = 2

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    addGateway () {
      return this.request('GATEWAY_ADD', this.paymentParams.gateway)
        .then(_ => {
          this.gatewayStatus = 1
        })
        .catch(error => {
          this.gatewayStatus = 2

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    // ***** INSTANCE *****
    instanceExist () {
      return this.request('INSTANCE_LIST')
        .then(response => {
          if (response.InstanceCount > 0) {
            // Pour chaque instance de PAX
            for (let i = 0; i < response.InstanceCount; i++) {
              // Pour chaque instance du paramétrage
              this.paymentParams.instance.forEach((instance, j) => {
                // Si instance existe et active
                if (
                  response[`InstanceName${i}`] === instance.InstanceName &&
                  response[`ApplicationType${i}`] === instance.ApplicationType &&
                  response[`InstanceStatus${i}`] === 'Actif'
                ) {
                  this.$set(this.instanceStatus, j, 1)
                }
              })
            }
          }
        })
        .catch(error => {
          for (let i = 0; i < this.instanceStatus.length; i++) {
            this.$set(this.instanceStatus, i, 2)
          }

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    addInstance (i) {
      return this.request('INSTANCE_ADD', this.paymentParams.instance[i])
        .then(_ => {
          this.$set(this.instanceStatus, i, 1)
        })
        .catch(error => {
          this.$set(this.instanceStatus, i, 2)

          if (error.ResponseInfo) {
            $alert(error.ResponseInfo)
          } else {
            $alert('Erreur pendant la configuration')
          }
        })
    },
    //
    /**
     * Promise resquest
     * @param action
     * @param params
     * @returns {Promise<unknown>}
     */
    request (action, params = {}) {
      return new Promise((resolve, reject) => {
        Pax.paxRequest(
          { action: action, params: params },
          (response) => {
            if (response.ResponseResult === '00') {
              resolve(response)
            } else {
              reject(response)
            }
          }
        )
      })
    }
  }
}
</script>
